module.exports = __webpack_public_path__ + "assets/img/23-l.56d993f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/23-l.jpg
// module id = HrYy
// module chunks = 0